import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { style: {"color":"red"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "d-flex px-6"
}
const _hoisted_6 = { style: {"font-size":"14px"} }
const _hoisted_7 = { key: 8 }
const _hoisted_8 = { style: {"width":"750px"} }
const _hoisted_9 = { style: {"width":"750px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { style: {"width":"750px"} }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { style: {"width":"750px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "pt-3 d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  color: "primary",
                  indeterminate: "",
                  class: "mr-3"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.formErrorMessage)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "1",
                class: "d-flex align-center justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    class: "mr-4",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.getBackAction()), ["stop"]))
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "11",
                class: "pt-3 d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.formErrorMessage), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (!_ctx.auditForm && !_ctx.hideHeader)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: "default_card_wm ma-2 py-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: !_ctx.vatItems && !_ctx.assistVatItems ? 10 : 9,
                      class: "d-flex align-center justify-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "1" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_back, {
                                  class: "mx-2",
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.getBackAction()), ["stop"]))
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: !_ctx.vatItems && !_ctx.assistVatItems ? 9 : 8,
                              class: "align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(_ctx.form.title ? `${_ctx.form.title} - ${_ctx.form.year}` : ""), 1)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.errorMessage)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      "no-gutters": "",
                                      class: "my-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("b", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["cols"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_col, {
                      cols: !_ctx.vatItems && !_ctx.assistVatItems ? 2 : 3,
                      class: "d-flex align-center justify-end px-3"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.autoDepositButtonDisplay)
                          ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                              key: 0,
                              rounded: "",
                              elevation: "0",
                              dark: "",
                              size: "small",
                              class: "mx-1",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.autoDepositValidationDialog = true)),
                              icon: "$fa-magic"
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.vatItems && _ctx.form.title)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              rounded: "",
                              elevation: "0",
                              disabled: 
                            !['EDITION', 'ERROR'].includes(_ctx.status) || _ctx.cerfaNumber === '3030SD'
                        ,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save(false))),
                              size: "small",
                              class: "mx-1"
                            }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode(" Enregistrer ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.form.title)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 2,
                              rounded: "",
                              elevation: "0",
                              disabled: _ctx.isDisabledValidateButton(),
                              onClick: _cache[4] || (_cache[4] = ($event: any) => {
                            _ctx.setAmountToPay();
                            _ctx.toggleConfirmDialog();
                        }),
                              class: "mx-1",
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode(" Valider et payer ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.form.title)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 3,
                              rounded: "",
                              elevation: "0",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleConfirmWithoutSendingDialog())),
                              class: "ml-1",
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode(" Valider sans envoyer ")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["cols"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64)),
    _createElementVNode("div", {
      style: _normalizeStyle(
                !_ctx.auditForm
                    ? 'height: 78vh; overflow-y: auto; border-top-left-radius: 25px; border-top-right-radius: 25px;'
                    : ''
            )
    }, [
      _createVNode(_component_v_form, {
        modelValue: _ctx.valid,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.valid) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_v_row, {
            "no-gutters": "",
            key: _ctx.reloadKey
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.tables, (table) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: table.title,
                  cols: _ctx.$vuetify.display.smAndDown ? 12 : table.size || 12,
                  class: "pa-2"
                }, {
                  default: _withCtx(() => [
                    (table && table.empty)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (table.title)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "d-flex px-6 py-4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, _toDisplayString(table.title), 1),
                                  (table.expandable)
                                    ? (_openBlock(), _createBlock(_component_v_spacer, { key: 0 }))
                                    : _createCommentVNode("", true),
                                  (table.expandable)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        onClick: ($event: any) => (table.expanded = !table.expanded),
                                        style: {"width":"40px"},
                                        class: "d-inline px-2",
                                        icon: 
                                        table.expanded
                                            ? '$keyboard_arrow_up'
                                            : 'keyboard_arrow_down'
                                    
                                      }, null, 8, ["onClick", "icon"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (!table.expandable || table.expanded)
                            ? (_openBlock(), _createBlock(_component_v_card, {
                                key: 1,
                                class: "default_card_wm fill-height",
                                elevation: "0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.rows, (row) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          cols: "12",
                                          key: row.key
                                        }, {
                                          default: _withCtx(() => [
                                            (row.title)
                                              ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(row.title), 1))
                                              : (_openBlock(), _createBlock(_component_v_row, {
                                                  key: 1,
                                                  "no-gutters": "",
                                                  class: _normalizeClass(
                                                _ctx.isSubTitle(row) ? 'pl-6 py-1 pt-2' : 'py-1 hover'
                                            )
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.isSubTitle(row))
                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                          key: 0,
                                                          cols: row.cols || 6,
                                                          class: "d-flex headline font-weight-bold titleclass"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(row.description), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["cols"]))
                                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                          (row.code)
                                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                                key: 0,
                                                                cols: "1",
                                                                class: "d-flex align-center justify-center headline"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("h5", null, _toDisplayString(row.code), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : _createCommentVNode("", true),
                                                          _createVNode(_component_v_col, {
                                                            cols: row.cols || 5,
                                                            class: "d-flex align-center pl-2"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(row.description), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["cols"])
                                                        ], 64)),
                                                    (row.values)
                                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(row.values, (field) => {
                                                          return (_openBlock(), _createBlock(_component_v_col, {
                                                            class: "d-flex align-center justify-center px-1",
                                                            key: field.key
                                                          }, {
                                                            default: _withCtx(() => [
                                                              (field.type === 'textarea')
                                                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_col, { cols: "3" }),
                                                                      _createVNode(_component_v_col, { cols: "9" }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_textarea_filled, {
                                                                            "no-resize": "",
                                                                            "auto-grow": "",
                                                                            rows: "1",
                                                                            modelValue: _ctx.fields[field.key],
                                                                            "onUpdate:modelValue": [($event: any) => ((_ctx.fields[field.key]) = $event), ($event: any) => (
                                                                        _ctx.reloadField(field)
                                                                    )],
                                                                            outlined: "",
                                                                            dense: "",
                                                                            "hide-details": "auto",
                                                                            mandatory: field.mandatory,
                                                                            readonly: 
                                                                        _ctx.isReadonly(field) ||
                                                                        _ctx.autoVatMode ||
                                                                        _ctx.readonly
                                                                    ,
                                                                            label: field.label
                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "mandatory", "readonly", "label"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024))
                                                                : (field.type === 'radio')
                                                                  ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                                                      key: 1,
                                                                      modelValue: _ctx.fields[field.key],
                                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.fields[field.key]) = $event),
                                                                      inline: "",
                                                                      rules: [
                                                                (v) =>
                                                                    !!v ||
                                                                    'Tous les champs sont obligatoires',
                                                            ],
                                                                      "hide-details": "auto",
                                                                      class: _normalizeClass(
                                                                field.values.length === 2 &&
                                                                field.values[0].value === 'yes'
                                                                    ? 'mt-0 pl-6'
                                                                    : 'mt-0'
                                                            ),
                                                                      color: "primary"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.values, (n) => {
                                                                          return (_openBlock(), _createBlock(_component_v_radio, {
                                                                            key: n.value,
                                                                            "onUpdate:modelValue": ($event: any) => (
                                                                    _ctx.reloadField(field)
                                                                ),
                                                                            readonly: 
                                                                    _ctx.isReadonly(field) ||
                                                                    _ctx.autoVatMode ||
                                                                    _ctx.readonly
                                                                ,
                                                                            outlined: "",
                                                                            "content-class": "oss- oss-text-field",
                                                                            dense: "",
                                                                            value: n.value
                                                                          }, {
                                                                            label: _withCtx(() => [
                                                                              _createElementVNode("div", _hoisted_6, _toDisplayString(n.text), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["onUpdate:modelValue", "readonly", "value"]))
                                                                        }), 128))
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["modelValue", "onUpdate:modelValue", "rules", "class"]))
                                                                  : (field.type === 'date')
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                        (field.key === 'startDate')
                                                                          ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                                                              key: 0,
                                                                              "filter-with-closed-accounting-periods": "",
                                                                              "hide-details": "auto",
                                                                              disabled: 
                                                                _ctx.getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) ||
                                                                !['EDITION', 'ERROR'].includes(
                                                                    _ctx.status,
                                                                )
                                                            ,
                                                                              "text-field-class": "oss-text-field",
                                                                              mandatory: field.mandatory || false,
                                                                              readonly: _ctx.isReadonly(field),
                                                                              textFieldReadOnly: false,
                                                                              label: field.label,
                                                                              "onUpdate:modelValue": ($event: any) => (_ctx.reloadField(field)),
                                                                              "model-value": _ctx.startDate
                                                                            }, null, 8, ["disabled", "mandatory", "readonly", "label", "onUpdate:modelValue", "model-value"]))
                                                                          : (field.key === 'endDate')
                                                                            ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                                                                key: 1,
                                                                                "filter-with-closed-accounting-periods": "",
                                                                                "hide-details": "auto",
                                                                                disabled: 
                                                                _ctx.getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) ||
                                                                !['EDITION', 'ERROR'].includes(
                                                                    _ctx.status,
                                                                )
                                                            ,
                                                                                "text-field-class": "oss-text-field",
                                                                                mandatory: field.mandatory || false,
                                                                                readonly: _ctx.isReadonly(field),
                                                                                textFieldReadOnly: false,
                                                                                label: field.label,
                                                                                "onUpdate:modelValue": ($event: any) => (_ctx.reloadField(field)),
                                                                                "model-value": _ctx.endDate
                                                                              }, null, 8, ["disabled", "mandatory", "readonly", "label", "onUpdate:modelValue", "model-value"]))
                                                                            : (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                                                                key: 2,
                                                                                modelValue: _ctx.fields[field.key],
                                                                                "onUpdate:modelValue": [($event: any) => ((_ctx.fields[field.key]) = $event), ($event: any) => (_ctx.reloadField(field))],
                                                                                "filter-with-closed-accounting-periods": "",
                                                                                "hide-details": "auto",
                                                                                disabled: 
                                                                _ctx.getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) ||
                                                                !['EDITION', 'ERROR'].includes(
                                                                    _ctx.status,
                                                                )
                                                            ,
                                                                                "text-field-class": "oss-text-field",
                                                                                mandatory: field.mandatory || false,
                                                                                readonly: _ctx.isReadonly(field),
                                                                                textFieldReadOnly: false,
                                                                                label: field.label
                                                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "mandatory", "readonly", "label"]))
                                                                      ], 64))
                                                                    : (field.type === 'boolean')
                                                                      ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                                                          key: 3,
                                                                          modelValue: _ctx.fields[field.key],
                                                                          "onUpdate:modelValue": [($event: any) => ((_ctx.fields[field.key]) = $event), ($event: any) => (_ctx.reloadField(field))],
                                                                          readonly: 
                                                                _ctx.isReadonly(field) || _ctx.autoVatMode
                                                            ,
                                                                          "hide-details": "",
                                                                          "false-value": '',
                                                                          "true-value": 'X',
                                                                          label: field.label,
                                                                          class: "mt-0 pt-0 mx-2",
                                                                          size: "small",
                                                                          color: "primary"
                                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "label"]))
                                                                      : (field.type === 'string')
                                                                        ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                                            key: 4,
                                                                            modelValue: _ctx.fields[field.key],
                                                                            "onUpdate:modelValue": [($event: any) => ((_ctx.fields[field.key]) = $event), ($event: any) => (_ctx.reloadField(field))],
                                                                            outlined: "",
                                                                            "hide-details": "",
                                                                            mandatory: field.mandatory,
                                                                            readonly: 
                                                                _ctx.isReadonly(field) || _ctx.autoVatMode
                                                            ,
                                                                            label: field.label,
                                                                            density: "compact"
                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "mandatory", "readonly", "label"]))
                                                                        : (field.type === 'title')
                                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                                              key: 5,
                                                                              class: "text-center .subtitle-2"
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createElementVNode("h4", null, _toDisplayString(field.default), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024))
                                                                          : (field.type === 'text')
                                                                            ? (_openBlock(), _createBlock(_component_v_col, { key: 6 }, {
                                                                                default: _withCtx(() => [
                                                                                  _createTextVNode(_toDisplayString(field.default), 1)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024))
                                                                            : (field.type === 'percentage')
                                                                              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                                                  key: 7,
                                                                                  modelValue: field.default,
                                                                                  "onUpdate:modelValue": [($event: any) => ((field.default) = $event), ($event: any) => (_ctx.reloadField(field))],
                                                                                  outlined: "",
                                                                                  "hide-details": "",
                                                                                  mandatory: field.mandatory,
                                                                                  readonly: 
                                                                _ctx.isReadonly(field) || _ctx.autoVatMode
                                                            ,
                                                                                  label: field.label,
                                                                                  density: "compact"
                                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "mandatory", "readonly", "label"]))
                                                                              : (field.type === 'empty')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                                                                                : (field.type === 'selector')
                                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                                                                      (
                                                                _ctx.decId &&
                                                                field.key === 'period' &&
                                                                _ctx.startDate === _ctx.endDate
                                                            )
                                                                                        ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                                                            key: 0,
                                                                                            modelValue: _ctx.fields[field.key],
                                                                                            "onUpdate:modelValue": ($event: any) => ((_ctx.fields[field.key]) = $event),
                                                                                            items: field.items,
                                                                                            outlined: "",
                                                                                            "content-class": "oss-text-field",
                                                                                            "hide-details": "auto",
                                                                                            required: "",
                                                                                            label: field.label,
                                                                                            mandatory: field.mandatory || false,
                                                                                            readonly: 
                                                                _ctx.isReadonly(field) || _ctx.autoVatMode
                                                            ,
                                                                                            rules: 
                                                                field.mandatory
                                                                    ? [
                                                                          (v) =>
                                                                              !!v ||
                                                                              'Ce champs est obligatoire',
                                                                      ]
                                                                    : undefined
                                                            ,
                                                                                            disabled: field.key === 'period',
                                                                                            density: "compact"
                                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label", "mandatory", "readonly", "rules", "disabled"]))
                                                                                        : (_openBlock(), _createBlock(_component_v_select_filled, {
                                                                                            key: 1,
                                                                                            modelValue: _ctx.fields[field.key],
                                                                                            "onUpdate:modelValue": ($event: any) => ((_ctx.fields[field.key]) = $event),
                                                                                            items: field.items,
                                                                                            "item-title": "text",
                                                                                            "item-value": "value",
                                                                                            outlined: "",
                                                                                            "content-class": "oss-text-field",
                                                                                            "hide-details": "auto",
                                                                                            required: "",
                                                                                            label: field.label,
                                                                                            mandatory: field.mandatory || false,
                                                                                            readonly: 
                                                                _ctx.isReadonly(field) || _ctx.autoVatMode
                                                            ,
                                                                                            rules: 
                                                                field.mandatory
                                                                    ? [
                                                                          (v) =>
                                                                              !!v ||
                                                                              'Ce champs est obligatoire',
                                                                      ]
                                                                    : undefined
                                                            ,
                                                                                            disabled: 
                                                                _ctx.getMandatoryConditionField(
                                                                    field.readOnlyConditionField,
                                                                ) || field.readonly
                                                            ,
                                                                                            "model-value": _ctx.startDate.substring(5, 7),
                                                                                            density: "compact"
                                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label", "mandatory", "readonly", "rules", "disabled", "model-value"]))
                                                                                    ], 64))
                                                                                  : (field.type !== 'radio')
                                                                                    ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                                                        key: 10,
                                                                                        outlined: "",
                                                                                        modelValue: _ctx.fields[field.key],
                                                                                        "onUpdate:modelValue": [($event: any) => ((_ctx.fields[field.key]) = $event), ($event: any) => (_ctx.reloadField(field))],
                                                                                        "hide-details": "auto",
                                                                                        disabled: field.disabled || false,
                                                                                        readonly: 
                                                                _ctx.isReadonly(field) ||
                                                                (_ctx.autoVatMode && field.key !== 'JB')
                                                            ,
                                                                                        mandatory: 
                                                                _ctx.getMandatoryConditionField(
                                                                    field.mandatoryConditionField,
                                                                )
                                                            ,
                                                                                        label: field.label || field.key,
                                                                                        rules: 
                                                                field.mandatory
                                                                    ? [
                                                                          (v) =>
                                                                              !!v ||
                                                                              'Ce champs est obligatoire',
                                                                      ]
                                                                    : undefined
                                                            ,
                                                                                        hint: _ctx.getHint(field),
                                                                                        "persistent-hint": !!_ctx.getHint(field)
                                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "readonly", "mandatory", "label", "rules", "hint", "persistent-hint"]))
                                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        }), 128))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class"]))
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128))
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 4),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.confirmWithoutSendingDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.confirmWithoutSendingDialog) = $event)),
      title: "Confirmation",
      onValid: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateWithoutSendingToMTAE())),
      validTitle: "Valider sans télédéclarer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createElementVNode("b", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir valider la déclaration sans la télédéclarer ni la payer ? Les éventuelles écritures comptables seront générées automatiquement. ", -1)
            ])),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.confirmDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.confirmDialog) = $event)),
      title: "Confirmation",
      onValid: _cache[11] || (_cache[11] = ($event: any) => (_ctx.generate())),
      validTitle: _ctx.validDeclarationTitle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (_ctx.amountToPay > 0 && !_ctx.bankAccounts.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[21] || (_cache[21] = [
                        _createElementVNode("b", {
                          style: {"color":"red"},
                          class: "text-center"
                        }, " Envoi d'un paiement impossible car aucun compte bancaire valide renseigné dans le dossier. L'envoi de la déclaration seule reste possible. ", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_ctx.amountToPay === 0 || _ctx.cerfaNumber === '2573SD')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "mb-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                      _createElementVNode("b", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir envoyer la déclaration ? ", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "mb-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("b", null, "Montant à payer : " + _toDisplayString(_ctx.amountToPay), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "mb-4"
                              }, {
                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                  _createElementVNode("b", null, "Montant restant à répartir :", -1)
                                ])),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentsList, (line, index) => {
                                return (_openBlock(), _createBlock(_component_v_row, {
                                  "no-gutters": "",
                                  key: index,
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "1" }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "d-flex justify-center align-center pr-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: line.bankAccountId,
                                          "onUpdate:modelValue": ($event: any) => ((line.bankAccountId) = $event),
                                          items: _ctx.bankAccounts,
                                          "item-title": "name",
                                          "item-value": "id",
                                          "item-disabled": _ctx.isItemDisabled,
                                          outlined: "",
                                          class: "text-field",
                                          "hide-details": "auto",
                                          required: "",
                                          label: "Compte bancaire",
                                          density: "compact"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-disabled"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex justify-center align-center pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          modelValue: line.amount,
                                          "onUpdate:modelValue": ($event: any) => ((line.amount) = $event),
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          label: "Montant"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex"
                                    }, {
                                      default: _withCtx(() => [
                                        (index > 0)
                                          ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                              key: 0,
                                              depressed: "",
                                              class: "mx-2 my-2",
                                              rounded: "circle",
                                              onClick: ($event: any) => (_ctx.deletePaymentLine(index)),
                                              size: "x-small"
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (
                                                index === _ctx.paymentsList.length - 1 &&
                                                _ctx.paymentsList.length < _ctx.bankAccounts.length
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_btn_add_icon, {
                                              key: 1,
                                              depressed: "",
                                              class: "mx-2 my-2",
                                              size: "x-small",
                                              fab: "",
                                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addPaymentLine())),
                                              disabled: !line.amount || !line.bankAccountId
                                            }, null, 8, ["disabled"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "pt-4"
                                    }, {
                                      default: _withCtx(() => [
                                        (!line.bankAccountId)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[24] || (_cache[24] = [
                                              _createElementVNode("b", {
                                                style: {"color":"red"},
                                                class: "text-center"
                                              }, " Envoi d'un paiement impossible car aucun compte bancaire sélectionné dans la liste. L'envoi de la déclaration seule reste possible. ", -1)
                                            ])))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]))
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "validTitle"]),
    (_ctx.autoDepositValidationDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 3,
          modelValue: _ctx.autoDepositValidationDialog,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.autoDepositValidationDialog) = $event)),
          title: "Suggestion",
          onValid: _cache[13] || (_cache[13] = ($event: any) => (_ctx.fillAutoDepositInDeclaration())),
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.autoDepositValidationDialog = false)),
          validTitle: "Appliquer"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              (_ctx.cerfaNumber === '3514SD')
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", _hoisted_16, " bobbee a trouvé le montant de l'acompte à déclarer : " + _toDisplayString(_ctx.vatAutoDepositAmount) + " €. Souhaitez-vous alimenter automatiquement le formulaire ? ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_ctx.cerfaNumber === '2571SD')
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                            _createElementVNode("b", { class: "text-center" }, " bobbee a trouvé le montant de l'acompte à déclarer. Souhaitez-vous alimenter automatiquement le formulaire ? ", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.ibanLimitDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 4,
          modelValue: _ctx.ibanLimitDialog,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ibanLimitDialog) = $event)),
          title: "Limite DGFIP",
          onValid: _cache[16] || (_cache[16] = ($event: any) => (_ctx.ibanLimitDialog = false)),
          validTitle: 'OK'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pt-3"
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createElementVNode("p", { class: "text-center" }, " La DGFIP fixe le nombre de comptes bancaires maximal à trois pour les paiements. ", -1)
                ])),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}